import { useLingui } from "@lingui/react/macro"
import React from "react"

import Subtitle from "../../../../design-system/subtitle"
import Title from "../../../../design-system/title"
import ButtonBookDemo from "../../../button-book-demo"
import ButtonPair from "../../../button-pair"
import SectionFooterCard from "../../../section-footer-card"
import * as styles from "./index.module.scss"
import { FooterCta } from "./types"

interface Props {
  footerCardCta?: FooterCta
}

const FooterCardCta: React.FC<Props> = ({ footerCardCta }) => {
  const { t } = useLingui()

  const defaultData = {
    title: t`Get started now`,
    subtitle: t`Our team is happy to show you how Tremendous is both simple and powerful. Or sign up for free, and see for yourself in minutes.`,
    buttons: undefined,
  }

  const data = footerCardCta ?? defaultData

  return (
    <SectionFooterCard size="small">
      <div className={styles.innerContainer}>
        <div className={styles.textContainer}>
          <Title as="h2">{data.title}</Title>
          <Subtitle as="p" className={styles.subtitle}>
            {data.subtitle}
          </Subtitle>
        </div>
        {footerCardCta?.buttons?.length ? (
          <div className={styles.buttonContainer}>
            {data?.buttons?.map((button, index) => (
              <ButtonBookDemo
                key={button.buttonId}
                text={button.text}
                href={button.path}
                buttonLocation="footer"
                buttonPosition={`${index + 1}`}
                area-current="page"
                target={button.targetBlank ? "_blank" : undefined}
                variant={index === 0 ? "primary" : "secondary"}
              />
            ))}
          </div>
        ) : (
          <ButtonPair location="footer" />
        )}
      </div>
    </SectionFooterCard>
  )
}

export default FooterCardCta
